import styled from "styled-components";

export const CenteredContent = styled.div`
    justify-content: center;
    align-items: center;
    padding: 30px;
    display: flex;
`;
